export default __webpack_public_path__ + "static/7-a9d6def24d8094d71570076b3ecfd161.png";